import usePostData from '../../../../../hooks/postHook';

export const useUpdateProductStatusBulk = () => {
  const [{ body, isLoading, isError, error }, doUpdate] = usePostData(
    'office_products/status'
  );

  return {
    body,
    isLoading,
    isError,
    error,
    doUpdate,
  };
};
